module.exports = __webpack_public_path__ + "img/MoMobil.730cb0df.png";